/**
 * Constructor method for creating instance of the (Top-level) sidebar nav used for managing the
 * state of the active navigation items when the keyboard is used for navigation
 *
 * Instance properties
 * - domNode : reference to domNode
 * - controllingMenuBtn : button which controls the sidebar
 * - navItems : list of all navItems within the top-level header nav
 * - firstChars : inventory of firstChars for identifying elements based on keypress
 * - firstItem : first headerNavItem within the nav
 * - lastItem : last headerNavItem within the nav
 * - closeBtn : reference to the close button node
 * - hasFocus : flag to identify current focus
 * - hasHover : flag to identify current hover
 *
 * @param {Node} domNode DomNode for the header nav
 */
const SidebarNav = function (domNode, menuBtn) {
  this.domNode = domNode;
  this.controllingMenuBtn = menuBtn;

  this.navItems = []; // See HeaderNav init method

  this.firstItem = null; // See HeaderNav init method
  this.lastItem = null; // See HeaderNav init method

  this.closeBtn = {};

  this.hasFocus = false; // See HeaderNav handleFocus, handleBlur
  this.hasHover = false; // See HeaderNav handleMouseover, handleMouseout
};

/*
 * Initializer for a HeaderNav instance
 *
 * Locate all navigation items (HeaderNavItems) within the HeaderNav which will be used
 * for activating the available subNav and external links. Push these items into a list and
 * set the first/last items in the list
 *
 */
SidebarNav.prototype.init = function () {
  let navItem, numItems;

  const sidebarNavItems = this.domNode.querySelectorAll(
    ":scope ul.side-nav-items a"
  );
  const closeBtn = this.domNode.querySelector(":scope #close-btn-desktop");

  for (let i = 0; i < sidebarNavItems.length; i++) {
    navItem = new SidebarNavItem(sidebarNavItems[i], this);
    navItem.init();
    this.navItems.push(navItem);
  }

  if (typeof closeBtn !== "undefined") {
    this.closeBtn.domNode = closeBtn;
    this.closeBtn.domNode.tabIndex = -1;
    this.navItems.push(this.closeBtn);
  }

  numItems = this.navItems.length;
  if (numItems > 0) {
    this.firstItem = this.navItems[0];
    this.lastItem = this.navItems[numItems - 1];
  }
};
/** FOCUS METHODS */

SidebarNav.prototype.close = function () {
  this.controllingMenuBtn.handleCloseSidebar();
};

SidebarNav.prototype.setFocusToItem = function (newItem) {
  newItem.domNode.focus();
};

SidebarNav.prototype.setFocusToClose = function () {
  this.setFocusToItem(this.closeBtn);
};

SidebarNav.prototype.setFocusToFirstItem = function () {
  this.setFocusToItem(this.firstItem);
};

SidebarNav.prototype.setFocusToLastItem = function () {
  this.setFocusToItem(this.lastItem);
};

SidebarNav.prototype.setFocusToPreviousItem = function (currentItem) {
  let index;

  if (currentItem === this.firstItem) {
    newItem = this.lastItem;
  } else {
    index = this.navItems.indexOf(currentItem);
    newItem = this.navItems[index - 1];
  }

  this.setFocusToItem(newItem);
};

SidebarNav.prototype.setFocusToNextItem = function (currentItem) {
  let index;

  if (currentItem === this.lastItem) {
    newItem = this.firstItem;
  } else {
    index = this.navItems.indexOf(currentItem);
    newItem = this.navItems[index + 1];
  }

  this.setFocusToItem(newItem);
};
